function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { action, define, observable } from '@formily/reactive';
import { message } from 'antd';
import _, { isArray } from 'lodash';
import React, { createContext, forwardRef, useContext, useEffect, useImperativeHandle, useMemo } from 'react';
import { useApiBaseinfoShopParseShopCode } from "./api/useApiBaseinfoShopParseShopCode";
import { useApiBaseinfoShopTree } from "./api/useApiBaseinfoShopTree";
import { useApiUCenterUserParseUserCode } from "./api/useApiUCenterParseUserCode";
import { useApiUCenterUserTree } from "./api/useApiUCenterUserTree";
export var SHOPTYPE = /*#__PURE__*/function (SHOPTYPE) {
  SHOPTYPE["ORG"] = "org";
  SHOPTYPE["CITY"] = "city";
  return SHOPTYPE;
}({});

// 这个主要是从后端接口返回的数据结构

/**
 * Upload 组件返回的结果
 */

export var Store = /*#__PURE__*/function () {
  function Store(_params, apiUCenterUserTree, apiBaseinfoShopTree, apiBaseinfoShopParseShopCode, apiUCenterUserParseUserCode) {
    var _this = this;
    _classCallCheck(this, Store);
    _defineProperty(this, "treeData", []);
    _defineProperty(this, "treeDataFlat", new Map());
    _defineProperty(this, "searchListFlat", new Map());
    _defineProperty(this, "selectedMap", new Map());
    _defineProperty(this, "checkedKeys", []);
    _defineProperty(this, "mode", 'user');
    _defineProperty(this, "shopType", SHOPTYPE.ORG);
    _defineProperty(this, "originSelected", []);
    /**
     * 获取选择项的接口
     */
    _defineProperty(this, "url", void 0);
    _defineProperty(this, "filter", void 0);
    /**
     * 批量上传的时候，需要上传excel，解析excel的接口
     */
    _defineProperty(this, "parseUrl", void 0);
    _defineProperty(this, "keyword", '');
    _defineProperty(this, "showSearch", false);
    _defineProperty(this, "apiUCenterUserTree", void 0);
    _defineProperty(this, "apiBaseinfoShopTree", void 0);
    _defineProperty(this, "apiBaseinfoShopParseShopCode", void 0);
    _defineProperty(this, "apiUCenterUserParseUserCode", void 0);
    _defineProperty(this, "onBatchImport", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(uploadResult) {
        var _uploadResult$upload$, _parseResult$data;
        var mode, parseApi, url, parseResult, newSelectedMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              mode = _this.mode;
              parseApi = mode === 'store' ? _this.apiBaseinfoShopParseShopCode : _this.apiUCenterUserParseUserCode;
              url = (uploadResult === null || uploadResult === void 0 || (_uploadResult$upload$ = uploadResult.upload[0]) === null || _uploadResult$upload$ === void 0 ? void 0 : _uploadResult$upload$.url) || '';
              if (url) {
                _context.next = 7;
                break;
              }
              console.error('uploadResult.upload[0].url is undefined or empty');
              message.error('导入失败');
              return _context.abrupt("return");
            case 7:
              _context.next = 9;
              return parseApi(_this.parseUrl, {
                url: uploadResult.upload[0].url
              });
            case 9:
              parseResult = _context.sent;
              if ((parseResult === null || parseResult === void 0 || (_parseResult$data = parseResult.data) === null || _parseResult$data === void 0 ? void 0 : _parseResult$data.length) > 0) {
                // 将新增的值放到前面
                _this.checkedKeys = [].concat(_toConsumableArray(parseResult.data), _toConsumableArray(_this.checkedKeys));

                // 更新selectedMap
                newSelectedMap = new Map();
                parseResult.data.forEach(function (item) {
                  // 从treeDataFlat中获取节点信息
                  var nodeData = _this.treeDataFlat[item];
                  if (nodeData) {
                    newSelectedMap.set(item, {
                      label: nodeData.name,
                      value: item,
                      path: nodeData.path
                    });
                  }
                });
                _this.selectedMap = new Map([].concat(_toConsumableArray(newSelectedMap), _toConsumableArray(_this.selectedMap)));
                message.success('导入成功');
              } else {
                message.error('文件中无有效数据');
              }
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    /**
     * Antd Tree组件的onCheck事件
     */
    _defineProperty(this, "onCheck", function (checkedKeysValue, info) {
      // 从info.checkedNodes过滤出叶子节点，更新this.selectedMap
      var newSelectedMap = new Map();
      var oldSelectedKeys = new Map();
      info.checkedNodes.forEach(function (node) {
        if (!node.children) {
          var nodeData = _this.treeDataFlat[node.key];
          // 解决treeDataFlat中没有的时候，搜索出的结果中有的情况
          if (!nodeData) {
            if (node.isLeaf) {
              newSelectedMap.set(node.key, {
                label: node.title,
                value: node.key,
                path: ''
              });
            }
          }
          if (nodeData !== null && nodeData !== void 0 && nodeData.leaf) {
            // 如果node 在this.selectedMap中，则为老的数据
            if (_this.selectedMap.has(node.key)) {
              oldSelectedKeys.set(node.key, _this.selectedMap.get(node.key));
            } else {
              newSelectedMap.set(node.key, {
                label: node.title,
                value: node.key,
                path: nodeData.path
              });
            }
          }
        }
      });

      // 还需要判断this.selectedMap中的数据是否在treeDataFlat中，如果不在，不能删除
      // 因为选门店的时候，按“组织架构”或者"行政区"里面的门店，可能数据不一样，比如组织架构里面有的门店，行政区里面没有
      _this.selectedMap.forEach(function (item, key) {
        if (!_this.treeDataFlat[key]) {
          oldSelectedKeys.set(key, item);
        }
      });

      // 新数据放到前面
      var tempSelectedMap = new Map([].concat(_toConsumableArray(newSelectedMap), _toConsumableArray(oldSelectedKeys)));
      _this.selectedMap = tempSelectedMap;

      // this.checkedKeys的结果取tempSelectedMap中的keys
      _this.checkedKeys = Array.from(tempSelectedMap.keys());
    });
    _defineProperty(this, "deleteSelected", function (item) {
      _this.selectedMap.delete(item.value);
      _this.checkedKeys = _this.checkedKeys.filter(function (key) {
        return key !== item.value;
      });

      // 移除搜索结果中的Checked状态
      var searchNode = _this.searchListFlat[item.value];
      if (searchNode) {
        searchNode.checked = false;
      }
    });
    _defineProperty(this, "addSelected", function (item) {
      // 将新增的值放到前面
      _this.selectedMap = new Map([[item.value, item]].concat(_toConsumableArray(_this.selectedMap)));
      if (!_this.checkedKeys.includes(item.value)) {
        _this.checkedKeys = [item.value].concat(_toConsumableArray(_this.checkedKeys));
      }
    });
    _defineProperty(this, "loadTree", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var mode, filter, result, treeData, _result, _treeData, originSelected;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            mode = _this.mode, filter = _this.filter;
            if (!(mode === 'store')) {
              _context2.next = 8;
              break;
            }
            _context2.next = 4;
            return _this.apiBaseinfoShopTree(_this.url, _.merge({}, {
              type: _this.shopType
            }, filter));
          case 4:
            result = _context2.sent;
            if (result && isArray(result) && result.length > 0) {
              treeData = _this.convertToTreeData(result);
              _this.treeData = treeData;
              _this.treeDataFlat = _this.treeFlat(result);
            }
            _context2.next = 13;
            break;
          case 8:
            if (!(mode === 'user')) {
              _context2.next = 13;
              break;
            }
            _context2.next = 11;
            return _this.apiUCenterUserTree(_this.url, _.merge({}, filter, {}));
          case 11:
            _result = _context2.sent;
            if (_result && isArray(_result) && _result.length > 0) {
              _treeData = _this.convertToTreeData(_result);
              _this.treeData = _treeData;
              _this.treeDataFlat = _this.treeFlat(_result);
            }
          case 13:
            originSelected = _this.originSelected;
            if (originSelected.length > 0) {
              _this.initSelected(originSelected);
            }
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    _defineProperty(this, "initSelected", function (originSelected) {
      // 通过originSelected，更新selectedMap
      var newSelectedMap = new Map();
      originSelected.forEach(function (item) {
        var nodeData = _this.treeDataFlat[item.value];
        if (nodeData) {
          newSelectedMap.set(item.value, {
            label: nodeData.name,
            value: item.value,
            path: nodeData.path
          });
        }
      });
      _this.selectedMap = newSelectedMap;
      _this.checkedKeys = Array.from(newSelectedMap.keys());
    });
    // 将result扁平化, 其中path是父节点name用"/"拼接的
    _defineProperty(this, "treeFlat", function (data) {
      var treeDataFlat = {};
      var flat = function flat(data) {
        var parentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        data.forEach(function (item) {
          treeDataFlat[item.code] = _objectSpread(_objectSpread({}, item), {}, {
            path: parentPath
          });
          if (item.children && item.children.length) {
            var newPath = parentPath ? "".concat(parentPath, "/").concat(item.name) : item.name;
            flat(item.children, newPath);
          }
        });
      };
      flat(data);
      return treeDataFlat;
    });
    /**
     * 将后端返回的数据转换成Antd TreeDataNode
     */
    _defineProperty(this, "convertToTreeData", function (data) {
      var treeData = [];
      data.forEach(function (item) {
        var node = {
          title: item.name,
          key: item.code
        };
        if (item.children && item.children.length) {
          node.children = _this.convertToTreeData(item.children);
        }
        treeData.push(node);
      });
      return treeData;
    });
    /**
     * 通过关键字获取搜索数据
     */
    _defineProperty(this, "fetchSearchList", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(keyword) {
        var mode, filter, params, searchApi, result, list;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this.keyword = keyword;
              mode = _this.mode, filter = _this.filter;
              params = _.merge({}, filter, {
                keyword: keyword
              });
              searchApi = {
                user: _this.apiUCenterUserTree,
                store: _this.apiBaseinfoShopTree
              };
              _context3.next = 6;
              return searchApi[mode](_this.url, params);
            case 6:
              result = _context3.sent;
              list = _this.treeFlat(result); // 移除搜索结果中的leaf===false的节点
              Object.values(list).forEach(function (node) {
                if (!node.leaf) {
                  delete list[node.code];
                }
              });

              // 遍历selectedMap中的数据，更新searchListFlat中的checked状态
              _this.selectedMap.forEach(function (item) {
                var node = list[item.value];
                if (node) {
                  node.checked = true;
                }
              });
              _this.searchListFlat = list;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    this.mode = _params.mode;
    this.originSelected = _params.value || [];
    this.filter = _params.filter || {};
    this.url = _params.url;
    this.parseUrl = _params.parseUrl;
    this.apiUCenterUserTree = apiUCenterUserTree;
    this.apiBaseinfoShopTree = apiBaseinfoShopTree;
    this.apiBaseinfoShopParseShopCode = apiBaseinfoShopParseShopCode;
    this.apiUCenterUserParseUserCode = apiUCenterUserParseUserCode;
    define(this, {
      /**
       * 树数据
       */
      treeData: observable,
      /**
       * 扁平化树数据
       */
      treeDataFlat: observable,
      /**
       * 选中的节点
       */
      selectedMap: observable.shallow,
      /**
       * 搜索结果数据
       */
      searchListFlat: observable,
      /**
       * chekced选中的节点
       */
      checkedKeys: observable,
      /**
       * 选择模式 user: 人 store: 门店
       */
      mode: observable,
      /**
       * store情况下，树的分类类型
       */
      shopType: observable,
      /**
       * 历史已经选择的人
       */
      originSelected: observable.shallow,
      /**
       * 搜索关键字
       */
      keyword: observable,
      /**
       * 显示搜索
       */
      showSearch: observable,
      /**
       * 初始化内部数据
       */
      initial: action,
      apiUCenterUserTree: action,
      apiBaseinfoShopTree: action,
      apiBaseinfoShopParseShopCode: action,
      apiUCenterUserParseUserCode: action,
      deleteSelected: action,
      addSelected: action,
      /**
       * 通过keyword获取搜索结果
       */
      fetchSearchList: action,
      onCheck: action,
      /**
       * 批量导入
       */
      onBatchImport: action,
      /**
       * 当前选择的所有节点数量统计
       */
      selectedCount: observable.computed,
      /**
       *  当前选择的所有节点
       */
      selected: observable.computed,
      /**
       * 搜索结果数据
       */
      searchListData: observable.computed,
      /**
       * filter是否传了自定义类型，目前默认的类型是"org", "city"
       */
      isCustomShopType: observable.computed
    });
  }
  _createClass(Store, [{
    key: "initial",
    value: function () {
      var _initial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.loadTree();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function initial() {
        return _initial.apply(this, arguments);
      }
      return initial;
    }()
  }, {
    key: "selectedCount",
    get: function get() {
      return this.selectedMap.size;
    }
  }, {
    key: "selected",
    get: function get() {
      return Array.from(this.selectedMap.values());
    }
  }, {
    key: "searchListData",
    get: function get() {
      return Object.values(this.searchListFlat);
    }
  }, {
    key: "isCustomShopType",
    get: function get() {
      var _this$filter;
      return ((_this$filter = this.filter) === null || _this$filter === void 0 ? void 0 : _this$filter.type) !== null;
    }
  }]);
  return Store;
}();
var useCreateStore = function useCreateStore(params) {
  var apiUCenterUserTree = useApiUCenterUserTree();
  var apiBaseinfoShopTree = useApiBaseinfoShopTree();
  var apiBaseinfoShopParseShopCode = useApiBaseinfoShopParseShopCode();
  var apiUCenterUserParseUserCode = useApiUCenterUserParseUserCode();
  var store = useMemo(function () {
    return new Store(params, apiUCenterUserTree, apiBaseinfoShopTree, apiBaseinfoShopParseShopCode, apiUCenterUserParseUserCode);
  }, [apiUCenterUserTree, apiBaseinfoShopTree, apiBaseinfoShopParseShopCode, apiUCenterUserParseUserCode, params]);
  useEffect(function () {
    store.initial();
  }, [store]);
  return store;
};
export var SelectContext = /*#__PURE__*/createContext(null);
export var SelectProvider = /*#__PURE__*/forwardRef(function (props, ref) {
  var store = useCreateStore(props);
  useImperativeHandle(ref, function () {
    return store;
  }, [store]);
  return /*#__PURE__*/React.createElement(SelectContext.Provider, {
    value: store
  }, props.children);
});
export var useSelectStore = function useSelectStore() {
  var store = useContext(SelectContext);
  if (!store) {
    throw new Error('useSelectStore must be used within a SelectProvider');
  }
  return store;
};